import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useUser } from '../contexts/UserContext';
import { Settings } from './Settings';
import { UserSettings } from '@/types/types';

interface SettingsModalProps {
  open: boolean;
  onClose: () => void;
  settings: UserSettings;
  setSettings: React.Dispatch<React.SetStateAction<UserSettings>>;
}

export const SettingsModal: React.FC<SettingsModalProps> = ({ open, onClose, settings, setSettings }) => {
  const [allFieldsFilled, setAllFieldsFilled] = useState(false);
  const { user } = useUser();

  useEffect(() => {
    const checkAllFieldsFilled = () => {
      const fields = [
        settings.preferredName,
        settings.cityState,
        settings.address,
        settings.aboutYou
      ];

      const areAllFilled = fields.every(field => field && field.trim() !== '');
      setAllFieldsFilled(areAllFilled);
    }
    checkAllFieldsFilled();
  }, [settings]);

  useEffect(() => {
    setSettings(user?.settings || {
      preferredName: '',
      cityState: '',
      address: '',
      aboutYou: ''
    });
  }, [setSettings, user?.settings]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent>
        <Settings
          onClose={onClose}
          settings={settings}
          setSettings={setSettings}
        />
      </DialogContent>
      <DialogActions>
        {allFieldsFilled && (
          <Button onClick={onClose}>Save</Button>
        )}
      </DialogActions>
    </Dialog>
  );
};